import React, {  useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import useCategoryToProductsList from "../../apiHooks/useCategoryToProductsList";
import useSelectedProduct from "../../componentHooks/useSelectedProduct";
import NoProductFound from "../../common/no-product-found/no-product-found.component";
import { ROUTES } from "../../constants/routes.constants";

import "./iot-category-to-apis-list.component.scss";


const IOTCategoryToApisList = ({ searchValue }) => {
  const history = useHistory();
  const { selectedProduct } = useSelectedProduct();
  const { content: productToApisList } = useCategoryToProductsList();
  
  const products2ApisList = useMemo(() => {
    const headingToProduct = productToApisList[selectedProduct.key];
    let newHeadingToProduct = {};
    if (searchValue?.length > 0) {
      for (let heading in headingToProduct) {
        const products = headingToProduct[heading];

        let filteredApisList =
          (products?.length > 0 &&
            products.filter(
              ({ title, description }) =>
                title?.toLowerCase().includes(searchValue.toLowerCase()) ||
                description?.toLowerCase().includes(searchValue.toLowerCase())
            )) ||
          [];
        if (filteredApisList.length > 0) {
          newHeadingToProduct[heading] = filteredApisList;
        }
      }
      return newHeadingToProduct;
    }
    return headingToProduct;
  }, [selectedProduct, searchValue,productToApisList ]);

  

  const onViewMore = (product, api) => {
    if (api.enabled === false) {
      return null;
    }

    history.push({
      pathname: ROUTES.PRODUCT_DETAILS
        .replace(":api", api.name)
        .replace(":product", api?.title),
      state: {
        product,
        api,
      },
    });
  };



  if (!products2ApisList || Object.values(products2ApisList).length === 0) {
    return <NoProductFound />;
  }
  return (
    <div className="apis_list">
      { products2ApisList && Object.keys(products2ApisList)?.map((product) => (
        <>
          <h1 className="text-3xl heading tracking-tight text-gray-900 api_product_heading">
            {product}
          </h1>
          <div className="api_list_container">
            {products2ApisList[product]?.map((api) => (
              <div
                className={`card max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 ${
                  api.enabled === false ? "disabled" : ""
                }`}
                onClick={() => onViewMore(product, api)}
              >
                <div
                  className="relative overflow-hidden bg-cover bg-no-repeat"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                >
                  {/* <img
                    className="rounded-t-lg"
                    src={
                      imageArray[Math.floor(Math.random() * imageArray.length)]
                    }
                    alt={api.title}
                  /> */}
                  <a>
                    <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsla(0,0%,98%,0.15)] bg-fixed opacity-0 transition duration-300 ease-in-out"></div>
                  </a>
                </div>
                <div className="p-6">
                  <h5 className=" api_title mb-2 text-xl font-medium leading-tight text-neutral-800 dark:text-neutral-50">
                    {api.title}
                  </h5>
                  <p className="api-description mb-4 text-base text-neutral-600 dark:text-neutral-200">
                    {api.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      ))}
    </div>
  );
};

export default IOTCategoryToApisList;
